var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var TextIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 36,
    glyphHeight: 36
  }), React.createElement("path", {
    d: "M9.60198 6.02808H12.682L19.486 25.3481L21.222 25.6281V27.0001H13.83V25.6281L16.154 25.3481L14.838 21.2041H6.66198L5.34598 25.3481L7.75398 25.6281V27.0001H1.11798V25.6281L2.85398 25.3481L9.60198 6.02808ZM11.366 10.5081L10.666 8.04408L9.99398 10.5641L7.16598 19.5521H14.306L11.366 10.5081Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M22.607 23.25C22.607 21.6833 23.3903 20.5333 24.957 19.8C26.5237 19.05 28.507 18.65 30.907 18.6V17.9C30.907 17.1166 30.8237 16.5 30.657 16.05C30.4903 15.6 30.1987 15.275 29.782 15.075C29.382 14.8583 28.807 14.75 28.057 14.75C27.207 14.75 26.4403 14.875 25.757 15.125C25.0903 15.3583 24.4237 15.65 23.757 16L23.132 14.7C23.3487 14.5166 23.7487 14.275 24.332 13.975C24.9153 13.675 25.5903 13.4083 26.357 13.175C27.1237 12.9416 27.8903 12.825 28.657 12.825C29.8403 12.825 30.7737 12.9916 31.457 13.325C32.157 13.6416 32.657 14.1583 32.957 14.875C33.257 15.5916 33.407 16.55 33.407 17.75V25.775H34.882V26.875C34.5487 26.9583 34.1237 27.0416 33.607 27.125C33.107 27.2083 32.6653 27.25 32.282 27.25C31.8153 27.25 31.4987 27.175 31.332 27.025C31.1653 26.8916 31.082 26.5833 31.082 26.1V25.275C30.582 25.775 29.9653 26.2333 29.232 26.65C28.5153 27.0666 27.6987 27.275 26.782 27.275C25.582 27.275 24.582 26.9333 23.782 26.25C22.9987 25.55 22.607 24.55 22.607 23.25ZM27.857 25.575C28.2903 25.575 28.7903 25.4416 29.357 25.175C29.9237 24.9083 30.4403 24.5916 30.907 24.225V19.925C29.0903 19.925 27.7153 20.2083 26.782 20.775C25.8653 21.325 25.407 22.05 25.407 22.95C25.407 23.85 25.6237 24.5166 26.057 24.95C26.507 25.3666 27.107 25.575 27.857 25.575Z",
    fill: "black"
  }));
};
export var TextIconGlyph = function (props) {
  return React.createElement(TextIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};